import script from "./aplayer.vue?vue&type=script&setup=true&lang=js"
export * from "./aplayer.vue?vue&type=script&setup=true&lang=js"

import "./aplayer.vue?vue&type=style&index=0&id=b5ab44c0&scoped=true&lang=less"

import exportComponent from "D:\\createProject\\吉幼美官网\\web\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ab44c0"]])

export default __exports__